import { FC, useState } from 'react';

import Button from '@ingka/button';
import Modal, { ModalBody, ModalFooter, ModalHeader, Sheets } from '@ingka/modal';
import { t } from '@onlinepayments/payments-library';

import orderImage from './../assets/example-order-nor.png';
import './LinkModal.scss';

interface ILinkModalProps {
  isOpen: boolean;
  onClose(): void;
}

const LinkModal: FC<ILinkModalProps> = ({ isOpen, onClose }) => {
  const [isZoomedIn, setIsZoomedIn] = useState<boolean>(false);
  const handleOrderImageClick = () => {
    setIsZoomedIn(!isZoomedIn);
  };

  return (
    <Modal visible={isOpen} handleCloseBtn={onClose} className="link-modal">
      <Sheets
        size="medium"
        header={<ModalHeader closeBtnClick={onClose} />}
        footer={
          <ModalFooter renderBorder>
            <Button type="primary" fluid>
              {t('link.link_modal_button')}
            </Button>
          </ModalFooter>
        }
      >
        <ModalBody>
          <h2>{t('link.link_modal_title')}</h2>
          <p>{t('link.link_modal_message')}</p>
          <div
            className="image-container"
            onClick={handleOrderImageClick}
            onKeyDown={handleOrderImageClick}
            role="button"
            tabIndex={-1}
          >
            <img
              src={orderImage}
              alt={t('link.link_modal_sample')}
              className={isZoomedIn ? 'zoomed' : ''}
            />
          </div>
        </ModalBody>
      </Sheets>
    </Modal>
  );
};

export default LinkModal;
